require('./polyfills');

module.exports = function(){
  document.querySelector('.page-loader').remove();
};


// WEBPACK FOOTER //
// ./src/js/loaded.js